module.exports = __webpack_public_path__ + "@/assets/img/creditos.d1d53184.svg";